import {Injectable} from '@angular/core';
import {EntityState, EntityStore, StoreConfig} from '@datorama/akita';
import {Transporter} from './model';

export interface TransporterState extends EntityState<Transporter> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'Transporter' })
export class Store extends EntityStore<TransporterState> {

  constructor() {
    super();
  }

}
